import sensors from '@/assets/sdk/sensorsdata.es6.min.js' // 引入神策sdk
window.sensors = sensors // 将神策对象放到全局变量中

import sensorsEvent from './sensorsEvent.js' // 引入封装好的神策埋点事件

let server_url, show_log

if (process.env.VUE_APP_NODE_ENV == 'production') { // 生产环境
    server_url = window.location.protocol + '//pcsac.pc.com.cn/sa?project=production'
    show_log = false
} else { // 非生产环境
    server_url = window.location.protocol + '//pcsac.pc.com.cn/sa?project=pcautotest'
    show_log = true
}

// 神策初始化
window.sensors.init({
    server_url, // 服务器URL
    show_log, // 日志打印
    use_app_track: false // 是否开启App打通H5
})

// 注册公共属性
window.sensors.registerPage({
    pcauto_activity_name: '埋点测试活动',
    current_url: function () {
        return window.location.href
    }
})

export default (Vue) => {
    // 将封装好的埋点事件放到Vue的原型中
    Vue.prototype.$sensorsEvent = {}
    Object.keys(sensorsEvent).forEach(item => {
        Vue.prototype.$sensorsEvent[item] = sensorsEvent[item]
    })
}
